import styled from 'styled-components';
import { WithBreakpointRange, isMobile, isMobileOrTablet, isTablet } from '@mews-commander/ui';
import { Container, Grid, WithChildren, getToken, withBreakpointRange } from '@optimus-web/core';
import { CardCustom } from '../CardCustom';

const CardWithShadow = styled(CardCustom)`
    box-shadow: ${getToken('shadow300')};
`;

const CalculatorPanelLayoutComponent: React.FC<WithBreakpointRange & WithChildren> = ({
    breakpointRange,
    children,
}) => (
    <Container padding={['0', (isMobile(breakpointRange) && '200') || (isTablet(breakpointRange) && '300') || '900']}>
        <Container position="relative" height={(isMobile(breakpointRange) && '375px') || '170px'}>
            <Container position="absolute" bottom="16px" left="0" right="0">
                <CardWithShadow
                    paddingHorizontal={
                        (isMobile(breakpointRange) && '300') || (isTablet(breakpointRange) && '400') || '700'
                    }
                    paddingVertical={(isMobileOrTablet(breakpointRange) && '500') || '700'}
                >
                    <Grid
                        templateColumns="1fr 2fr"
                        gap={(isMobileOrTablet(breakpointRange) && '300') || '1200'}
                        tabletMax={{ templateColumns: '1fr' }}
                    >
                        {children}
                    </Grid>
                </CardWithShadow>
            </Container>
        </Container>
    </Container>
);

export const CalculatorPanelLayout = withBreakpointRange(CalculatorPanelLayoutComponent);
